export default function CategoriesSection() {
  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl text-white mb-6">
            Loyalty Goes Both Ways
          </h2>
          <div className="max-w-3xl mx-auto space-y-4">
            <p className="text-gray-300 text-lg leading-relaxed">
              At High Standards Smoke Shop, we believe loyalty should always be returned.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              When our customers support us, we give back — through exclusive in-store events, seasonal giveaways, and special surprises throughout the year.
            </p>
            <p className="text-copper text-xl font-medium mt-6">
              Because to us, you're not just a customer.<br />
              You're part of the High Standards community.
            </p>
          </div>
        </div>

        {/* Event Image */}
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <div className="relative w-full h-[600px]">
              <img
                src="https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/7ab87f607f75961522a90a24cc0735b0.jpeg"
                alt="High Standards Smoke Shop Community Event"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent"></div>
            </div>
            
            {/* Bottom Accent */}
            <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-copper via-amber-500 to-copper"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
